// latest: zhangmyh 2017-3-14 9:16 PM
import { Collection } from 'common'
import evalApply from 'model/evaluationApply'

evalApply('scheme')

Collection.define('evalSchemeList', {
  model: 'evalapply.scheme',
  proxy: {
    get: '/cpu-supplymgr/evaluateScheme/pageQuery',
    // count: '/cpu-supplymgr/evaluateApply/count'
  }
})

export default Collection.create('evalSchemeList')



// WEBPACK FOOTER //
// ./src/data/collection/evaluationApply/scheme.js